module.exports = __webpack_public_path__ + "static/img/case_detail_17_1.7e3f0a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_17_1.png
// module id = TNfx
// module chunks = 34